import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Page, Action } from "../MVP/shared";
import { PageHeader } from "../../components/UI";
import LanguageMenu from "../../components/UI/LanguageMenu";
import BrandMark from "../../components/Layout/BrandMark";
import { useLanguage } from "../../contexts/LanguageContext";

/* Системные состояния маршрутов: неизвестный адрес и раздел без прав.
   Это не загрузочная ошибка и не 404 объекта — действие зависит только от сессии. */

const Canvas = styled.main`
  min-height: 100svh;
  display: grid;
  grid-template-rows: auto 1fr;
  padding: 16px clamp(16px, 4vw, 48px) 48px;
  background: ${(p) => p.theme.colors.background};
  color: ${(p) => p.theme.colors.text};
  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 56px;
  }
`;
const Body = styled.div`
  align-self: center;
  justify-self: center;
  display: grid;
  gap: 8px;
  width: 100%;
  max-width: 560px;
  .code {
    font-size: 14px;
    font-weight: 600;
    color: ${(p) => p.theme.colors.textMuted};
    font-variant-numeric: tabular-nums;
  }
  .acts {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 16px;
  }
`;

/** Неизвестный адрес. Внутри оболочки — для сессии, отдельной страницей — без неё. */
export function NotFound({ authenticated }: { authenticated: boolean }) {
  const { t } = useLanguage();
  if (authenticated) {
    return (
      <Page>
        <PageHeader
          title={t("sys.not_found")}
          description={t("sys.not_found_text")}
          actions={
            <Action as={Link} to="/" $variant="primary">
              {t("match.to_home")}
            </Action>
          }
        />
      </Page>
    );
  }
  return (
    <Canvas>
      <header>
        <Link to="/" aria-label={t("sys.to_start")}>
          <BrandMark />
        </Link>
        <LanguageMenu />
      </header>
      <Body>
        <span className="code">404</span>
        <PageHeader title={t("sys.not_found")} description={t("sys.not_found_text")} />
        <div className="acts">
          <Action as={Link} to="/" $variant="primary">
            {t("sys.to_start")}
          </Action>
          <Action as={Link} to="/login">
            {t("auth.sign_in")}
          </Action>
        </div>
      </Body>
    </Canvas>
  );
}

/** Раздел существует, но роли недостаточно. Права проверяет сервер; здесь только честное сообщение. */
export function Forbidden() {
  const { t } = useLanguage();
  return (
    <Page>
      <PageHeader
        title={t("sys.forbidden")}
        description={t("sys.forbidden_text")}
        actions={
          <Action as={Link} to="/" $variant="primary">
            {t("match.to_home")}
          </Action>
        }
      />
    </Page>
  );
}
